function getIP(json) {
  const expectedDeliveryTime = document.querySelector('.product-delivery-time');
  expectedDeliveryTime.style.display = 'none';

  if (expectedDeliveryTime) {
    const locationSelect = expectedDeliveryTime.querySelector('select[name="location"]');
    const defaultLocation = expectedDeliveryTime.dataset.defaultLocation;
    const defaultRegion = expectedDeliveryTime.dataset.defaultRegion;
    const countryData = JSON.parse(expectedDeliveryTime.dataset.objectData);

    // Default values
    let deliveryDays = 3;
    let orderBeforeHours = 12;
    let country = json.countryCode;
    let region = '';

    if (countryData) {
      countryData.forEach(function(location) {
        if (location.countryCode === json.countryCode && location.region === json.region) {
          region = location.region;
          let locationData = countryData.find(location => location.countryCode === json.countryCode);
          if (region && region !== 'undefined' && region !== 'null' && region !== '') {
            locationData = countryData.find(location => location.countryCode === json.countryCode && location.region === region);
          }
          deliveryDays = parseInt(locationData.days);
          orderBeforeHours = parseInt(locationData.hours);
          country = locationData.country;
          countDown(deliveryDays, orderBeforeHours, region, country);
        }

        if (location.countryCode === json.countryCode) {
          region = location.region;
          let locationData = countryData.find(location => location.countryCode === json.countryCode);
          if (region && region !== 'undefined' && region !== 'null' && region !== '') {
            locationData = countryData.find(location => location.countryCode === json.countryCode && location.region === region);
          }
          deliveryDays = parseInt(locationData.days);
          orderBeforeHours = parseInt(locationData.hours);
          country = locationData.country;
          countDown(deliveryDays, orderBeforeHours, region, country);
        }

        // Default location
        if (defaultLocation && defaultLocation !== 'undefined' && defaultLocation !== 'null' && defaultLocation !== '') {
          region = defaultRegion;

          let defaultLocationData = countryData.find(location => location.countryCode === defaultLocation);
          if (region && region !== 'undefined' && region !== 'null' && region !== '') {
            defaultLocationData = countryData.find(location => location.countryCode === defaultLocation && location.region === region);
          }
          deliveryDays = parseInt(defaultLocationData.days);
          orderBeforeHours = parseInt(defaultLocationData.hours);
          country = defaultLocationData.country;

          countDown(deliveryDays, orderBeforeHours, region, country);
        }
      });
    }

    if (locationSelect) {
      // Update the location select
      const selectedLocationOptions = locationSelect.querySelectorAll('option');
      // When default location is set
      if (defaultLocation && defaultLocation !== 'undefined' && defaultLocation !== 'null' && defaultLocation !== '') {
        selectedLocationOptions.forEach(function(option) {
          if (option.value === defaultLocation) {
            option.selected = true;
          } else {
            option.selected = false;
          }
        });
      }

      // When default location and region is set
      if (defaultRegion && defaultRegion !== 'undefined' && defaultRegion !== 'null' && defaultRegion !== '') {
        selectedLocationOptions.forEach(function(option) {
          if (option.value === defaultLocation && option.dataset.region === defaultRegion) {
            option.selected = true;
          } else {
            option.selected = false;
          }
        });
      }
      //when no default location is set
      if (defaultLocation == 'undefined' || defaultLocation == 'null' || defaultLocation == '') {
        selectedLocationOptions.forEach(function(option) {
          if (option.value === json.countryCode) {
            option.selected = true;
          } else {
            option.selected = false;
          }
        });
      }

      locationSelect.addEventListener('change', function() {
        const selectedLocationOptions = locationSelect.querySelectorAll('option');
        selectedLocationOptions.forEach(function(option) {
          if (option.selected) {
            const selectedLocation = option.value;
            const selectedEmirate = option.dataset.region;

            let selectedLocationData = countryData.find(location => location.countryCode === selectedLocation);
            if (selectedEmirate && selectedEmirate !== 'undefined' && selectedEmirate !== 'null' && selectedEmirate !== '') {
              selectedLocationData = countryData.find(location => location.countryCode === selectedLocation && location.region === selectedEmirate);
            }
            if (selectedLocationData) {
              const deliveryDays = parseInt(selectedLocationData.days);
              const orderBeforeHours = parseInt(selectedLocationData.hours);

              country = selectedLocationData.country;

              if (selectedLocationData.region_name !== '') {
                region = selectedLocationData.region_name;
              } else {
                region = selectedLocationData.region;
              }

              countDown(deliveryDays, orderBeforeHours, region, country);
            }
          }
        });
      });
    }
  }
}

function countDown(deliveryDays, orderBeforeHours, region, country){
  window.intervalId ? clearInterval(this.intervalId) : console.log('clear interval');
  const expectedDeliveryTime = document.querySelector('.product-delivery-time');
  //const deliveryLocation = expectedDeliveryTime.querySelector('[data-current-location]');
  const deliveryTime = expectedDeliveryTime.querySelector('[data-delivery-time]');
  const deliveryDate = expectedDeliveryTime.querySelector('[data-delivery-date]');

  // Set the delivery date
  var DeliveryDate = new Date();
  DeliveryDate.setDate(DeliveryDate.getDate() + deliveryDays);

  const newMonth = DeliveryDate.toLocaleString('default', { month: 'long' });
  const newWeekday= DeliveryDate.toLocaleString('default', { weekday: 'long' });
  const newDay = DeliveryDate.toLocaleString('default', { day: 'numeric' });
  const newYear = DeliveryDate.toLocaleString('default', { year: 'numeric' });

  deliveryDate.textContent = newWeekday + ' ' + newMonth + ' ' + newDay + ', ' + newYear + '.';

  // Set the date we're counting down to
  var countDownTime = new Date();
  countDownTime.setHours(orderBeforeHours,0,0,0);

  // Update the count down every 1 second
  var x = setInterval(function() {

    // Get today's date and time
    var now = new Date().getTime();
    // Find the distance between now and the count down date
    var distance = countDownTime - now;

    // If the count down is finished, write some text
    if (distance < 0) {
      // add a day when the delivery date is expired and start counting down again
      DeliveryDate.setDate(DeliveryDate.getDate() + 1);

      const newMonth = DeliveryDate.toLocaleString('default', { month: 'long' });
      const newWeekday= DeliveryDate.toLocaleString('default', { weekday: 'long' });
      const newDay = DeliveryDate.toLocaleString('default', { day: 'numeric' });
      const newYear = DeliveryDate.toLocaleString('default', { year: 'numeric' });

      deliveryDate.textContent = newWeekday + ' ' + newMonth + ' ' + newDay + ', ' + newYear + '.';

      countDownTime = DeliveryDate;
      countDownTime.setHours(orderBeforeHours,0,0,0);
      distance = countDownTime - now;
    }

    // Time calculations for days, hours, minutes and seconds
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result
    deliveryTime.textContent = hours + "h " + minutes + "m " + seconds + "s";

    expectedDeliveryTime.style.display = 'flex';
  }, 1000);

  window.intervalId = x;
}